import { useEffect, useState } from "react";

export const useDebouncedValue = (query: string, timeout: number) => {
  const [debouncedValue, setDebouncedValue] = useState(query);

  useEffect(() => {
    if (!query) {
      setDebouncedValue("");
      return;
    }

    let cancelled = false;

    const handle = setTimeout(() => {
      if (!cancelled) {
        setDebouncedValue(query);
      }
    }, timeout);

    return () => {
      cancelled = true;
      clearTimeout(handle);
    };
  }, [query, timeout]);

  return debouncedValue;
};
